import { Component, DOMAttributes } from "react"
import { actOnEnterOrSpace } from "../../common/js-utils"
import "./Checkbox.less"

type tProps = {
    id?: string
    isChecked: boolean
    onChange: () => void
    disabled?: boolean
}

class StyledCheckbox extends Component<tProps & DOMAttributes<HTMLSpanElement>> {
    render(): JSX.Element {
        const { id, isChecked, onChange, disabled } = this.props
        return (
            <span
                id={id ? id : ""}
                className="styled-checkbox"
                onClick={() => !disabled && onChange()}
                onKeyDown={e => !disabled && actOnEnterOrSpace(e, onChange)}
                tabIndex={0}
                role="checkbox"
                aria-checked={isChecked}
            >
                <input className="styled-checkbox-input" type="checkbox" checked={isChecked} readOnly disabled={disabled} />
                <span className="styled-checkbox-box"></span>
                <span className={`styled-checkbox-val ${isChecked ? "styled-checkbox-yes" : "styled-checkbox-no"} ${disabled ? "styled-checkbox-disabled" : ""}`}>{isChecked ? "Yes" : "No"}</span>
            </span>
        )
    }
}

export default StyledCheckbox
